/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { CalendarDays, CheckCircle2, AlertCircle } from "lucide-react";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";

const inputCls =
  "w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400";
const labelCls = "block mb-1.5 text-sm font-medium text-slate-700 dark:text-slate-300";

function UploadMartByDate() {
  const [period, setPeriod] = useState("");
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!period || !date) return;
    setIsLoading(true);
    setResponse(null);
    // Convert date from YYYY-MM-DD (HTML input) to MM-DD-YYYY (API format)
    const [y, m, d] = date.split("-");
    const formattedDate = `${m}-${d}-${y}`;
    try {
      await axiosInstance.put(
        `/loans/update-mart/date?period=${encodeURIComponent(period)}&date=${encodeURIComponent(formattedDate)}`
      );
      setResponse({ state: "SUCCESS", message: `Mart records for period "${period}" updated with date ${formattedDate}.` });
      toast.success("Mart records updated successfully");
      setPeriod("");
      setDate("");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Update failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Update Mart by Date">
      <div className="max-w-md">
        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-slate-200 dark:border-gray-700 shadow-sm overflow-hidden">
          <div className="px-6 py-5 border-b border-slate-100 dark:border-gray-700 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
              <CalendarDays size={18} className="text-emerald-600 dark:text-emerald-400" />
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-800 dark:text-slate-100">Update Mart Records by Date</h3>
              <p className="text-xs text-slate-500 dark:text-slate-400">Set the date for all mart deduction records in a given period</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div>
              <label className={labelCls}>Period</label>
              <input
                type="text"
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                placeholder="e.g. JAN26"
                required
                className={inputCls}
              />
              <p className="text-xs text-slate-400 mt-1">The period identifier on the existing mart records</p>
            </div>

            <div>
              <label className={labelCls}>New Date</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
                className={inputCls}
              />
            </div>

            {response?.state === "SUCCESS" && (
              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800">
                <CheckCircle2 size={16} className="text-emerald-600 flex-shrink-0" />
                <p className="text-sm text-emerald-700 dark:text-emerald-300 font-medium">{response.message}</p>
              </div>
            )}
            {response?.state === "ERROR" && (
              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800">
                <AlertCircle size={16} className="text-red-600 flex-shrink-0" />
                <p className="text-sm text-red-700 dark:text-red-300 font-medium">{response.message}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={!period || !date || isLoading}
              className="w-full py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Updating..." : "Update Mart Records"}
            </button>
          </form>
        </div>
      </div>
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadMartByDate;
